import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, TemplateRef } from '@angular/core';
import { QuestionnaireService } from '../../services/questionnaire/questionnaire.service';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { WarningModalContentComponent } from 'src/app/lib/warning-modal/warning-modal.component';
import { EditQuestionnaireTitleModalComponent } from '../../modules/questionnaire/components/edit-questionnaire-name/edit-questionnaire-title-modal.component';
import { QuestionnaireUserPermissionModalComponent } from '../../components/questionnaire-user-permission-modal/questionnaire-user-permission-modal.component';
import { PreviewQuestionnaireComponent } from '../../components/preview-questionnaire/preview-questionnaire.component';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import * as Cookies from 'js-cookie';
import moment from 'moment-timezone';
import { AlertBannerService, AlertType } from '../../lib/alert-banner/alert-banner.service';
import { environment } from 'src/environments/environment';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import {SurveyHelpModalComponent} from "../../components/survey-help-modal/survey-help-modal.component";
import {
  SurveyUserPermissionModalComponent
} from "../../components/survey-user-permission-modal/survey-user-permission-modal.component";
import {
  CreateReferenceSurveyComponent
} from "../../components/create-reference-survey/create-reference-survey.component";
import { FilterOutput } from "../../components/filter-v3/filter-v3.types";
import { FilterEntry } from "./questionnaires.types";

@Component({
  selector: 'app-questionnaires',
  templateUrl: './questionnaires.component.pug',
  styleUrls: ['./questionnaires.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class QuestionnairesComponent implements OnInit {
  questionnaireKebabMenuOptions: any[] = [];
  questionnaires: any[] = [];
  total = 5;
  modalTemplateHeader = '';
  modalTemplateContent = '';
  rowsPerView = 20;
  questionnaire: any;
  selectedOrgUid = Cookies.get(ConstantsService.ORG_COOKIE);
  currentPage = 1;
  editTitleModal: BsModalRef = new BsModalRef();
  deletewarningModal: BsModalRef = new BsModalRef();
  pulseWarningModal: BsModalRef = new BsModalRef();
  @ViewChild('modalTemplate') pulseTemplate!: TemplateRef<any>;
  questionnaireUserPermissionModalComponent: BsModalRef = new BsModalRef();
  previewQuestionnaireComponent: BsModalRef = new BsModalRef();
  configureOptInModal:BsModalRef = new BsModalRef();
  displayPagination = true;
  searchOptions = [{'label':$localize`Survey`,'hint':$localize`Survey title`,'value':'title'}, {'label':$localize`Created by`,'hint':$localize`First or last name`,'value':'name'}];
  filterOptions: FilterEntry[] = [];
  requestTemplate = false;
  sortOptions = [
    {
      'label': $localize`Last updated`,
      'type': "number",
      'value': "modified"
    },
    {
      'label': $localize`Survey title`,
      'type': "word",
      'value': "title"
    },
    {
      'label': $localize`Times used`,
      'type': "number",
      'value': "count"
    }
  ];
  sortString='-modified';
  searchOption: any = undefined;
  createButtonDisable = true;
  createNewDisableRP = false;
  canSetQuestionnairePermissions = false;
  disableEditQuestionnaire = false;
  exitSurveyTabActive = false;
  loading = true;
  engageUrl: string = environment.ENGAGE_URL;
  user_uid = '';
  addOrder = 0;
  selectedColumns: any = [];
  selectedTab = 'all';
  survey_type_mapping = QuestionnaireService.survey_type_mapping;
  comingSoon = $localize`Coming soon`;
  checkForLoop = false;
  searchTags: any = [];
  searchTitle = $localize`Sorry, we couldn’t find any results`
  searchDescription = $localize`Try another search term or adjust the filters.`
  searchImg = 'https://assets.xref.com/omni/shared/tmp_console_no_vendors.svg'
  surveysHelpModal: BsModalRef;
  noPermission= false;
  heading: any;
  subHeading: any;
  btnText = $localize`Request access`;
  createRefSurvey = false;
  viewSurvey = false;
  createPulseSurvey = false;
  createExitSurvey = false;
  canPreviewRefSurvey = false;
  canPreviewExitSurvey = false;
  canPreviewPulseSurvey = false;
  canPreviewRefSurveyWithPerms = false;
  canPreviewExitSurveyWithPerms = false;
  canPreviewPulseSurveyWithPerms = false;
  canManageRefSurvey = false;
  canManageExitSurvey = false;
  canManagePulseSurvey = false;
  canManageOwnRefSurvey = false;
  canManageOwnExitSurvey = false;
  canManageOwnPulseSurvey = false;
  fields: any[] = [];

  constructor( private router: Router,
              private modalService: BsModalService,
              private questionnaireService: QuestionnaireService,
              private permissions: PermissionsService,
              private alertList: AlertBannerService,
              public organisationService: OrganisationService
  ) {
    this.surveysHelpModal = new BsModalRef();
  }


  ngOnInit(): void {
    this.requestTemplate = this.permissions.isFeatureActivated('ent-10605-request-templates');
    if(this.requestTemplate){
        this.sortOptions[2].type = 'frequency'
    }
    const surveyPermissions = [
      'can_view_reference_surveys_list',
      'can_view_pulse_surveys_list',
      'can_view_exit_surveys_list',
      'can_view_reference_surveys_list_with_survey_perms',
      'can_view_pulse_surveys_list_with_survey_perms',
      'can_view_exit_surveys_list_with_survey_perms'
    ];

    this.viewSurvey = surveyPermissions.some(permission => this.permissions.hasPermission(permission));

    this.createRefSurvey = this.permissions.hasPermission('can_create_reference_surveys')
    this.createPulseSurvey = this.permissions.hasPermission('can_create_pulse_surveys')
    this.createExitSurvey = this.permissions.hasPermission('can_create_exit_surveys')

    this.canPreviewRefSurvey = this.permissions.hasPermission('can_preview_reference_surveys')
    this.canPreviewExitSurvey = this.permissions.hasPermission('can_preview_exit_surveys')
    this.canPreviewPulseSurvey = this.permissions.hasPermission('can_preview_pulse_surveys')
    this.canPreviewRefSurveyWithPerms = this.permissions.hasPermission('can_preview_reference_surveys_with_survey_perms')
    this.canPreviewExitSurveyWithPerms = this.permissions.hasPermission('can_preview_exit_surveys_with_survey_perms')
    this.canPreviewPulseSurveyWithPerms = this.permissions.hasPermission('can_preview_pulse_surveys_with_survey_perms')

    this.canManageRefSurvey = this.permissions.hasPermission('can_manage_reference_surveys')
    this.canManageExitSurvey = this.permissions.hasPermission('can_manage_exit_surveys')
    this.canManagePulseSurvey = this.permissions.hasPermission('can_manage_pulse_surveys')
    this.canManageOwnRefSurvey = this.permissions.hasPermission('can_manage_own_reference_surveys')
    this.canManageOwnExitSurvey = this.permissions.hasPermission('can_manage_own_exit_surveys')
    this.canManageOwnPulseSurvey = this.permissions.hasPermission('can_manage_own_pulse_surveys')

    this.setFilter();
      // while removing this feature flag please update the variable initialization on line 36. TA!
    this.sortOptions[1] = {...this.sortOptions[1], label : $localize`Survey title`};
    this.createButtonDisable = !this.permissions.hasPermission('create_questionnaire');
    this.canSetQuestionnairePermissions = this.permissions.hasPermission('set_permission_on_questionnaire');
    this.disableEditQuestionnaire = !this.permissions.hasPermission('edit_questionnaire');
    let selectedTab = localStorage.getItem('questionnaire-page-selected-tab');
    if (selectedTab){
      this.selectedTab = selectedTab;
    }
    this.exitSurveyTabActive = true;
    this.user_uid = this.permissions.data?.user?.uid;
  }

  private setFilter() {
    this.organisationService.getOrganisation().subscribe(data => {
      this.fields = [
        {
          key: 'created_by',
          label: $localize`Created by`,
          type: 'filterToggleGroup',
          options: [
            {label: $localize`Xref`, value: 'xref', selected: false},
            {label: $localize`My organisation`, value: data.uid, selected: false },
            {label: $localize`Only me`, value: 'user', selected: false},
          ],
        },
        {
          key: 'status',
          label: 'Survey status',
          type: 'filterToggleGroup',
          options: [
            {label: $localize`Active`, value: 'active', selected: true},
            {label: $localize`Deactivated`, value: 'deactivated', selected: false},
          ],
        },
      ];
    });
  }

  public openEngageUrl(){
    window.open(this.engageUrl + ConstantsService.ENGAGE_UTM_URL, "_blank");
    return;
  }

  editQuestionnnaire(questionnaireId, isNew=false, survey_type){
    const survey_type_text = Object.keys(this.survey_type_mapping).find(type=>this.survey_type_mapping[type]==survey_type)
    localStorage.setItem('survey_type', survey_type_text ? survey_type_text : 'reference');
    if(isNew) this.router.navigateByUrl('surveys/create', { state:{questionnaireId, isNew} });
    else this.router.navigateByUrl('surveys/edit', { state:{questionnaireId, isNew} });
    return false;
  }

  deleteQuestionnaire(q){
    const survey_type_text = Object.keys(this.survey_type_mapping).find(type=>this.survey_type_mapping[type]==q.survey_type)
    if (survey_type_text === 'pulse' && q.is_scheduled) {
      this.modalTemplateHeader = $localize`Delete survey`;
      this.modalTemplateContent = $localize`This survey is associated with a scheduled Pulse request and cannot be deleted. Please replace the survey in the Pulse request and try again.`;
      this.pulseWarningModal = this.modalService.show(this.pulseTemplate, {
        class: 'modal-dialog-centered m-popup'
      });
      return false;
    }
    const questionnaire_title = q.questionnaire.name;
    const initialState = {
      'title': $localize`Delete survey?`,
      'message': $localize`Are you sure you want to delete ${questionnaire_title}?`
    }
    this.deletewarningModal = this.modalService.show(
      WarningModalContentComponent,
      { class: 'modal-dialog-centered default-modal', initialState},
    );
    this.deletewarningModal.content.closeBtnName = 'Close';
    this.deletewarningModal.content.selection.subscribe((res)=>{
      if(res){
        let survey_type = this.selectedTab!='all' ? this.survey_type_mapping[this.selectedTab] : '';
        this.questionnaireService.deleteQuestionnaire(q.questionnaire.id).subscribe(
          success => {
            this.questionnaireService.getQuestionnairesDuplicateParams(this.searchOption, this.rowsPerView, this.currentPage, this.sortString, undefined, survey_type, undefined, true).subscribe(
              (questionnaireRes) => {
                this.questionnaires = questionnaireRes?.data?.questionnaires;
                this.total = questionnaireRes?.data?.total;
                this.currentPage = 1;
                this.questionnaires.forEach(questionnaire => {
                  this.setDeletePermissions(questionnaire);
                  this.setFormattedDate(questionnaire);
                  this.setPermissions(questionnaire);
                  this.initialiseKebabMenuOptions(questionnaire);
                });
                this.noPermission = false
                if (this.selectedTab === 'reference') {
                  this.createNewDisableRP = !this.createRefSurvey;
                } else if (this.selectedTab === 'exit') {
                  this.createNewDisableRP = !this.createExitSurvey;
                } else if (this.selectedTab === 'pulse') {
                  this.createNewDisableRP = !this.createPulseSurvey;
                } else if (this.selectedTab === 'all') {
                  this.createNewDisableRP = !(this.createRefSurvey || this.createExitSurvey || this.createPulseSurvey);
                }
                // this.total = res.data.total;
                this.loading = false;
              }, error => {
                if (this.selectedTab == 'all') {
                  this.heading = $localize`Request access`;
                  this.subHeading = $localize`Access this page upon being granted permission.`;
                } else if (this.selectedTab != 'all') {
                  this.heading = $localize`Request access to ${this.capitalizeFirstLetter(this.selectedTab)} surveys`;
                  this.subHeading = $localize`Access this page upon being granted permission.`;
                }
                this.questionnaires = []
                this.noPermission = true;
              }
            );
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! The survey, ${questionnaire_title}, has been deleted.`,
              keepOnRouteChange: true
            }])
          },
          err => console.log(err));
        }
      });
    return false;
  }

  deleteQuestionnaireDeprecated(questionnaire){
    const questionnaire_title = questionnaire.name;
    const initialState = {
      'title': $localize`Delete survey?`,
      'message': $localize`Are you sure you want to delete ${questionnaire_title}?`
    }
    this.deletewarningModal = this.modalService.show(
      WarningModalContentComponent,
      { class: 'modal-dialog-centered default-modal', initialState},
    );
    this.deletewarningModal.content.closeBtnName = 'Close';
    this.deletewarningModal.content.selection.subscribe((res)=>{
      if(res){
        let survey_type = this.selectedTab!='all' ? this.survey_type_mapping[this.selectedTab] : '';
        this.questionnaireService.deleteQuestionnaire(questionnaire.id).subscribe(
          success => {
            this.questionnaireService.getQuestionnairesDuplicateParams(this.searchOption, this.rowsPerView, this.currentPage, this.sortString, undefined, survey_type, undefined, true).subscribe(
              (questionnaireRes) => {
                this.questionnaires = questionnaireRes?.data?.questionnaires;
                this.total = questionnaireRes?.data?.total;
                this.currentPage = 1;
                this.questionnaires.forEach(questionnaire => {
                  this.setDeletePermissions(questionnaire);
                  this.setFormattedDate(questionnaire);
                  this.setPermissions(questionnaire);
                  this.initialiseKebabMenuOptions(questionnaire)
                });
                this.noPermission = false
                if (this.selectedTab === 'reference') {
                  this.createNewDisableRP = !this.createRefSurvey;
                } else if (this.selectedTab === 'exit') {
                  this.createNewDisableRP = !this.createExitSurvey;
                } else if (this.selectedTab === 'pulse') {
                  this.createNewDisableRP = !this.createPulseSurvey;
                } else if (this.selectedTab === 'all') {
                  this.createNewDisableRP = !(this.createRefSurvey || this.createExitSurvey || this.createPulseSurvey);
                }

                // this.total = res.data.total;
                this.loading = false;
              }, error => {
                if (error.status === 403) {
                  if (this.selectedTab == 'all') {
                    this.heading = $localize`Request access`;
                    this.subHeading = $localize`Access this page upon being granted permission.`;
                  } else if (this.selectedTab != 'all') {
                    this.heading = $localize`Request access to ${this.capitalizeFirstLetter(this.selectedTab)} surveys`;
                    this.subHeading = $localize`Access this page upon being granted permission.`;
                  }
                  this.questionnaires = []
                  this.noPermission = true;
                }
              }
            );
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! The survey, ${questionnaire_title}, has been deleted.`,
              keepOnRouteChange: true
            }])
          },
          err => console.log(err));
        }
      });
    return false;
  }

  editQuestionnaireTitle(questionnaire){
    this.questionnaire = questionnaire
    const initialState = {
      'questionnaireId': this.questionnaire.id,
      'questionnaireTitle': this.questionnaire.name
    };
    this.editTitleModal = this.modalService.show(
      EditQuestionnaireTitleModalComponent,
      {class: 'modal-dialog-centered default-modal', initialState},
    );
    this.editTitleModal.content.questionnaireTitleChange.subscribe(res => {
      this.editQuestionnaireTitleService(questionnaire.id, res.data);
    });
    this.editTitleModal.content.closeBtnName = 'Close';
    return false;

  }

  editQuestionnaireTitleService(questionnaireId, name){
    const questionnaireBody = {};
    questionnaireBody['id'] = questionnaireId
    questionnaireBody['name'] = name;
    this.questionnaireService.putQuestionnaireTitle(questionnaireBody).subscribe(res=>{
      if ( res['status_message'] == "ok" ) {
        let doc = document.getElementById(questionnaireId)
        if (doc!=null){
          doc.innerText = res.data.name
          this.questionnaire.name = res.data.name
        }
      }
    })
  }

  editUserPermissions(questionnaire){
    const initialState = {
      'questionnaireId': questionnaire.questionnaire.id,
      'created_by': questionnaire.created_by
    };
    initialState['questionnaireTitle'] = questionnaire.name;
    initialState['questionnaireProduct'] = this.getSurveyType(questionnaire.survey_type);

    this.questionnaireUserPermissionModalComponent = this.modalService.show(
        SurveyUserPermissionModalComponent,
        {class: 'modal-dialog-centered xl-popup', initialState},
    );


    return false
  }

  getSurveyType(surveyType) {
    const matchingKey = Object.keys(this.survey_type_mapping).find(key =>
      String(this.survey_type_mapping[key]) === surveyType
    );
    return matchingKey ? matchingKey.charAt(0).toUpperCase() + matchingKey.slice(1) : "-";
  }

  onPreview(questionnaireId){
    const initialState={
      'questionnaireId': questionnaireId
    };
    this.previewQuestionnaireComponent = this.modalService.show(
      PreviewQuestionnaireComponent,
      { class: 'preview-modal', initialState},
    )
  }

  configureOptIn(questionnaire){
    const initialState = {
        'questionnaireId': questionnaire.questionnaire.id,
        'isEditTitle': true,
        'configureOptInOnly': true,
      }
    this.configureOptInModal = this.modalService.show(
      CreateReferenceSurveyComponent,
      { class: 'modal-dialog-centered xl-popup', initialState},
    )
  }

  editNotesToCandidateAndReferee(questionnaire) {
    this.loading = true;
    this.questionnaireService.getQuestionnaire(questionnaire.questionnaire.id).subscribe(
      res => {
        const initialState = {
            'questionnaireId': questionnaire.questionnaire.id,
            'isEditTitle': true,
            'configureNotesToCandidateAndReferee': true,
            'noteToCandidate': res.data?.config?.notes?.note_to_candidate || '',
            'noteToReferee': res.data?.config?.notes?.note_to_referee || '',
            'minReferee': res.data?.config?.min_referee || ConstantsService.DEFAULT_REFEREE_COUNT,
            'questionnaireData': res.data
          }
        this.configureOptInModal = this.modalService.show(
          CreateReferenceSurveyComponent,
          { class: 'modal-dialog-centered xl-popup', initialState},
        );
        this.loading = false;
      }, error => {
        this.loading = false;
        console.error('Failed to load questionnaire details:', error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }


  onPageChange(pageNumber){
    this.currentPage = pageNumber;
    this.initialiseQuestionnaires();
  }

  onPageSizeChange(rowsPerView){
    this.rowsPerView = rowsPerView;
    this.currentPage = 1;
    this.initialiseQuestionnaires();
  }

  onSortChange(sortString:any): void{
    this.sortString = sortString;
    this.initialiseQuestionnaires();
  }

  onSearchChange(searchOutput){
    this.searchTags = [...this.searchTags]
    this.searchTags.unshift(searchOutput)
    this.searchOption = this.createSearchOption()
    this.initialiseQuestionnaires();
  }

  onRemoveSearchTag(searchOutput){
    this.searchTags = searchOutput
    this.searchOption = this.createSearchOption()
    this.initialiseQuestionnaires();
  }

  setDeletePermissions(questionnaire) {
    questionnaire.canDelete = true;
    if (questionnaire.times_used !== 0) {
      questionnaire.canDelete = false;
      return
    }
  }
  setPermissions(questionnaire){
    questionnaire.optionDisabled = false;
    questionnaire.canManage = false;
    questionnaire.canPreview = false;
    questionnaire.canDuplicateAndEdit = false;

    if (questionnaire.survey_type == this.survey_type_mapping['reference']) {
      questionnaire.canDuplicateAndEdit = this.createRefSurvey;
      questionnaire.canPreview = this.canPreviewRefSurvey || this.canPreviewRefSurveyWithPerms;
      questionnaire.canManage = this.canManageRefSurvey || this.canManageOwnRefSurvey;
      if (this.canManageOwnRefSurvey && this.user_uid !== questionnaire.created_by?.uid) {
        questionnaire.optionDisabled = true;
      }
    }
    if (questionnaire.survey_type == this.survey_type_mapping['exit']) {
      questionnaire.canDuplicateAndEdit = this.createExitSurvey;
      questionnaire.canPreview = this.canPreviewExitSurvey || this.canPreviewExitSurveyWithPerms;
      questionnaire.canManage = this.canManageExitSurvey || this.canManageOwnExitSurvey;
      if (this.canManageOwnExitSurvey && this.user_uid !== questionnaire.created_by?.uid) {
        questionnaire.optionDisabled = true;
      }
    }
    if (questionnaire.survey_type == this.survey_type_mapping['pulse']) {
      questionnaire.canDuplicateAndEdit = this.createPulseSurvey;
      questionnaire.canPreview = this.canPreviewPulseSurvey || this.canPreviewPulseSurveyWithPerms;
      questionnaire.canManage = this.canManagePulseSurvey || this.canManageOwnPulseSurvey;
      if (this.canManageOwnPulseSurvey && this.user_uid !== questionnaire.created_by?.uid) {
        questionnaire.optionDisabled = true;
      }
    }
  }

  setFormattedDate(questionnaire){
    if(questionnaire['created']){
      questionnaire['created_formatted'] = moment(questionnaire['created']).format('ll');
    }
    if(questionnaire['modified']){
      questionnaire['modified_formatted'] = moment(questionnaire['modified']).format('ll');
    }
  }

  onSelectedTab(tab){
    if (this.selectedTab !== tab) {
      this.currentPage = 1;
    }
    this.selectedTab = tab;
    localStorage.setItem('questionnaire-page-selected-tab', this.selectedTab);
    this.initialiseQuestionnaires();
  }

  calculateLastPossiblePage(total, rPv)
  {
    return Math.ceil(total/rPv);
  }

  capitalizeFirstLetter(value: string): string {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  initialiseKebabMenuOptions(questionnaire) {
    questionnaire.kebabMenuOptions = [];

    this.questionnaireKebabMenuOptions = [
      {
          key: '0',
          value: $localize`Survey permissions`,
          id: 'permissions',
          condition: !questionnaire.questionnaire?.is_default && questionnaire.canManage,
          disabled: questionnaire.optionDisabled,
          data_test_id: 'survey-permission'
      },
      {
          key: '1',
          value: $localize`Configure opt-in question`,
          id:'optIn',
          condition: !questionnaire.questionnaire?.is_default && questionnaire.canManage
              && questionnaire?.survey_type==this.survey_type_mapping['reference'],
          disabled: questionnaire.optionDisabled,
          data_test_id: 'configure-opt-in-question'
      },
      {
          key: '2',
          value: $localize`Edit notes to candidate and referee`,
          id:'notes',
          condition: !questionnaire.questionnaire?.is_default && questionnaire.canManage
              && questionnaire?.survey_type==this.survey_type_mapping['reference'],
          disabled: questionnaire.optionDisabled,
          data_test_id: 'note-to-candidate-and-referee'
      },
      {
          key: '3',
          value: $localize`Rename survey`,
          id: 'rename',
          condition: !questionnaire.questionnaire?.is_default && questionnaire.canManage && this.RenameCond(questionnaire),
          disabled: questionnaire.optionDisabled,
          data_test_id: 'rename-survey'
      },
      {
          key: '4',
          value: $localize`Edit survey`,
          id: 'edit',
          condition: !questionnaire.questionnaire?.is_default && questionnaire.canManage && questionnaire.times_used === 0 && !questionnaire.questionnaire?.is_migrated_from_xrp,
          disabled: questionnaire.optionDisabled,
          data_test_id: 'edit-survey'
      },
      {
          key: '5',
          value: $localize`Duplicate and edit`,
          id: 'duplicate',
          condition: questionnaire.canDuplicateAndEdit,
          disabled: false,
          data_test_id: 'duplicate-edit-survey'
      },
      {
          key: '6',
          value: $localize`Preview`,
          id: 'preview',
          condition: questionnaire.canPreview,
          disabled: false,
          data_test_id: 'preview-survey'
      },
      {
          key: '7',
          value: $localize`Activate survey`,
          condition: !questionnaire.activated && questionnaire.canManage,
          id: 'activate',
          disabled: questionnaire.optionDisabled,
          divider: true,
          data_test_id: 'activate-survey'
      },
      {
          key: '8',
          value: $localize`Deactivate survey`,
          condition: questionnaire.activated && questionnaire.canManage,
          id: 'deactivate',
          disabled: questionnaire.optionDisabled,
          divider: true,
          data_test_id: 'deactivate-survey'
      },
      {
          key: '9',
          value: $localize`Delete survey`,
          id: 'delete',
          condition: !questionnaire.questionnaire?.is_default && questionnaire.canManage && questionnaire.canDelete,
          disabled: questionnaire.optionDisabled,
          data_test_id: 'delete-survey'
      },
    ];
    this.questionnaireKebabMenuOptions.forEach(option => {
        if (option.condition) {
            questionnaire.kebabMenuOptions.push({
              key: option.key,
              value: option.value,
              id: option.id,
              divider: option.divider,
              disabled: option.disabled,
              data_test_id: option.data_test_id
            });
        }
      });

  }

  kebabMenuChange($event, questionnaire) {
    if ($event.disabled) return;
    const handler = this.kebabMenuHandlers[$event.id];
    if (handler) {
      handler(questionnaire);
    }
  }

  activateSurvey(questionnaire, active: boolean) {
    const survey_type_text = Object.keys(this.survey_type_mapping).find(type=>this.survey_type_mapping[type]==questionnaire.survey_type)
    if (survey_type_text === 'pulse' && questionnaire.is_scheduled) {
      this.modalTemplateHeader = $localize`Deactivate survey`;
      this.modalTemplateContent = $localize`This survey is associated with a scheduled Pulse request and cannot be deactivated. Please replace the survey in the Pulse request and try again.`;
      this.pulseWarningModal = this.modalService.show(this.pulseTemplate, {
        class: 'modal-dialog-centered m-popup'
      });
      return;
    }
    this.questionnaireService.activateSurvey(questionnaire.id, active).subscribe(res => {
      questionnaire.activated = active
      this.initialiseKebabMenuOptions(questionnaire)
      /*
        TODO: Success message might be needed, will uncomment or delete once finalised with PM.
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: active ? $localize`Survey activated successfully` : $localize`Survey deactivated successfully`,
        keepOnRouteChange: true
      }]);
      */
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  cancelTemplate() {
    this.pulseWarningModal.hide();
  }

  kebabMenuHandlersDeprecated: { [key: string]: (q: any) => void } = {
    '0': (q) => this.editUserPermissions(q),
    '1': (q) => this.configureOptIn(q),
    '2': (q) => this.editQuestionnaireTitle(q.questionnaire),
    '3': (q) => this.editQuestionnnaire(q.questionnaire.id, false, q.survey_type),
    '4': (q) => this.editQuestionnnaire(q.questionnaire.id, true, q.survey_type),
    '5': (q) => this.onPreview(q.questionnaire.id),
    '6': (q) => this.deleteQuestionnaireDeprecated(q.questionnaire)
  };

  kebabMenuHandlers: { [id: string]: (q: any) => void } = {
    'permissions': (q) => this.editUserPermissions(q),
    'optIn': (q) => this.configureOptIn(q),
    'notes': (q) => this.editNotesToCandidateAndReferee(q),
    'rename': (q) => this.editQuestionnaireTitle(q.questionnaire),
    'activate': (q) => this.activateSurvey(q, true),
    'deactivate': (q) => this.activateSurvey(q, false),
    'edit': (q) => this.editQuestionnnaire(q.questionnaire.id, false, q.survey_type),
    'duplicate': (q) => this.editQuestionnnaire(q.questionnaire.id, true, q.survey_type),
    'preview': (q) => this.onPreview(q.questionnaire.id),
    'delete': (q) => this.deleteQuestionnaire(q)
  };

  initialiseQuestionnaires(){
    let survey_type = this.selectedTab != 'all' ? this.survey_type_mapping[this.selectedTab] : '';
    this.loading = true;
    this.permissions.initializePermissions().then(() => {
      this.loading = false;
      if (this.selectedTab == 'reference') {
        this.viewSurvey = this.permissions.hasPermission('can_view_reference_surveys_list') ||
          this.permissions.hasPermission('can_view_reference_surveys_list_with_survey_perms')
      } else if (this.selectedTab == 'exit') {
        this.viewSurvey = this.permissions.hasPermission('can_view_exit_surveys_list') ||
          this.permissions.hasPermission('can_view_exit_surveys_list_with_survey_perms')
      } else if (this.selectedTab == 'pulse') {
        this.viewSurvey = this.permissions.hasPermission('can_view_pulse_surveys_list') ||
          this.permissions.hasPermission('can_view_pulse_surveys_list_with_survey_perms')
      } else {
        this.viewSurvey = this.permissions.hasPermission('can_view_reference_surveys_list') ||
          this.permissions.hasPermission('can_view_pulse_surveys_list') ||
          this.permissions.hasPermission('can_view_exit_surveys_list') ||
          this.permissions.hasPermission('can_view_reference_surveys_list_with_survey_perms') ||
          this.permissions.hasPermission('can_view_pulse_surveys_list_with_survey_perms') ||
          this.permissions.hasPermission('can_view_exit_surveys_list_with_survey_perms')
      }
      if(!this.viewSurvey)
      {
        if (this.selectedTab == 'all') {
          this.heading = $localize`Request access`;
          this.subHeading = $localize`Access this page upon being granted permission.`;
        } else if (this.selectedTab != 'all') {
          this.heading = $localize`Request access to ${this.capitalizeFirstLetter(this.selectedTab)} surveys`;
          this.subHeading = $localize`Access this page upon being granted permission.`;
        }
        this.questionnaires = []
        this.noPermission = true;
      }
      else{
        this.loading = true;
        this.questionnaireService.getQuestionnairesDuplicateParams(this.searchOption, this.rowsPerView, this.currentPage, this.sortString, undefined,survey_type,undefined, true, this.filterOptions).subscribe(
        (res) => {
            this.questionnaires = res.data.questionnaires;
            this.questionnaires.forEach(questionnaire=>{
              this.setDeletePermissions(questionnaire);
              this.setFormattedDate(questionnaire);
              this.setPermissions(questionnaire);
              this.initialiseKebabMenuOptions(questionnaire)
            });
            this.total = res.data.total;
            this.loading = false;
            if(this.checkForLoop) { this.checkForLoop = false; }
            else if (this.total > 0 && (this.questionnaires.length == 0))
            {
              this.currentPage = this.calculateLastPossiblePage(this.total, this.rowsPerView);
              this.initialiseQuestionnaires();
              this.checkForLoop = true;
            }
            this.noPermission = false
            if (this.selectedTab === 'reference') {
              this.createNewDisableRP = !this.createRefSurvey;
            } else if (this.selectedTab === 'exit') {
              this.createNewDisableRP = !this.createExitSurvey;
            } else if (this.selectedTab === 'pulse') {
              this.createNewDisableRP = !this.createPulseSurvey;
            } else if (this.selectedTab === 'all') {
              this.createNewDisableRP = !(this.createRefSurvey || this.createExitSurvey || this.createPulseSurvey);
            }
          }, error => {
            if (error.status === 403) {
              if (this.selectedTab == 'all') {
                this.heading = $localize`Request access`;
                this.subHeading = $localize`Access this page upon being granted permission.`;
              } else if (this.selectedTab != 'all') {
                this.heading = $localize`Request access to ${this.capitalizeFirstLetter(this.selectedTab)} surveys`;
                this.subHeading = $localize`Access this page upon being granted permission.`;
              }
              this.questionnaires = []
              this.noPermission = true;
            } else {
              console.log(error);
              this.alertList.append([{
                type: AlertType.DANGER,
                message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                keepOnRouteChange: true
              }]);
            }
            this.loading = false;
        });
      }
    })
  }

  RenameCond(questionnaire) {
    if(questionnaire.times_used>0) {
      return false
    } else {
      return true
    }
  }

  createSearchOption(): { key: string; value: string }[] {
    return this.searchTags.map(item => ({
      key: item.value === '' ? 'all' : item.value,
      value: item.term
    }));
  }

  showHelp() {
    this.surveysHelpModal = this.modalService.show(SurveyHelpModalComponent, {
      class: 'modal-dialog-centered xl-popup'
    });
  }

  onRequestAccess($:any) {
    let params = {}
    if(this.selectedTab=='all'){
      params={
        template_type: 'all_survey'
      }
    }
    if(this.selectedTab=='reference'){
      params={
        template_type:'hybrid',
        product: 'Reference'
      }
    }
    if(this.selectedTab=='exit'){
      params={
        template_type:'hybrid',
        product: 'Exit'
      }
    }
    if(this.selectedTab=='pulse'){
      params={
        template_type:'hybrid',
        product: 'Pulse'
      }
    }

    this.permissions.requestAccess(
      params
    ).subscribe(
      (res) => {
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Your request has been sent successfully. You will be notified once your request has been approved.`,
          keepOnRouteChange: true
        }]);
      },
      (error) => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    )
  }

  applyFilter(output: FilterOutput) {
    this.filterOptions = [];
    if (output['created_by']) {
      this.filterOptions.push({'key': 'created_by', 'value': output['created_by']});
    }
    if (output['status'].length === 1 && output['status'][0] === 'active') {
      this.filterOptions.push({'key': 'active', 'value': true});
    } else if (output['status'].length === 1 && output['status'][0] === 'deactivated') {
      this.filterOptions.push({'key': 'active', 'value': false});
    } else {
      this.filterOptions = this.filterOptions.filter(item => item.key !== 'active');
    }
    this.initialiseQuestionnaires();
  }
}
